// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_CONTRIBUTORS_IN_LAST_WEEK = ["%(count)s \u010dlov\u011bk p\u0159isp\u011bl za t\u00fdden", "%(count)s lid\u00e9 p\u0159isp\u011bli za t\u00fdden", "%(count)s lid\u00ed p\u0159isp\u011blo za t\u00fdden"];
